import React from "react";
import { useSelector } from "react-redux";

import { CategoryPageSkeleton } from "../../component/skeleton/CategoryPageSkeleton";
import { RefundTablePage } from "./refundTable/RefundTablePage";
import { RefundFilterPage } from "./refundFilter/RefundFilterPage";

import classes from "./refundListPage.module.css";

export const RefundListPage = () => {
  return (
    <div className={classes.box}>
      <RefundFilterPage />
      <RefundTablePage />
    </div>
  );
};
